export default __webpack_public_path__ + "static/media/jupyter.450a53e0.png";